import { useState, useEffect } from "react";

import styled from "styled-components";
import { IoIosArrowBack } from "react-icons/io";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import UserCreationLayout from "../../layouts/userCreation/userCreationLayout";
import IntroSection from "../../components/introSection/introSection";
import Divider from "../../components/divider/divider";
import Input from "../../components/input/input";
import Button from "../../components/button/button";
import { Colors } from "../../utilities/colors";
import { useNavigate, useLocation } from "react-router-dom";
import ErrorField from "../../components/errorField/errorField";
import { forgotPasswordValidation, forgotPasswordEmail, onTriggerOtp, onOtpVerify } from "../../services/apiCalls";
import Loader from "../../components/loader/loader";
// styling starts
const Label = styled.label`
  font-weight: 500;
  display: block;
`;

const LabelHighlightText = styled(Label)`
  color: ${Colors.inputHighlightText};
  font-size: 12px;
  line-height: 16px;
  align-self: center;
  cursor: pointer;
  text-decoration: underline;
`;
const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  @media (max-width: 650px) {
    display: block;
  }
`;
const LabelText = styled.label`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
`;
const SignUpBtn = styled(LabelText)`
  color: ${Colors.primary};
  text-decoration: underline;
  margin-left: 10px;
  cursor: pointer;
`;

const FormWrapper = styled.div`
  margin: 10px 0px;
  max-width: 440px;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;
const FlexBox = styled.div`
  display: flex;
`;
const EmailHeader = styled(FlexBox)`
  justify-content: space-between;
`;
const Fintext = styled(FlexBox)`
  margin-top: 20px;
`;
const _text_ = styled.span`
  font-size: 14px;
  color: #a2a2a2;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  margin-right: 2px;
`;

const FormLabel = styled(Label)`
  font-size: 16px;
  line-height: 22px;
  color: #202020;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const GroupWrapper = styled.div`
  margin-bottom: 40px;
`;
const UserHelpText = styled(Label)`
  color: ${Colors.inputHighlightText};
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
  text-align: right;
  text-decoration: underline;
`;
const InputOtp = {
  background: Colors.blogTextBox,
  padding: "12px 20px",
  outline: "none",
  width: "-webkit-fill-available",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "22px",
  color: Colors.primary,
  boxSizing: "border-box",
  borderRadius: "10px",
  maxWidth: "54px",
  marginRight: "10px",
  border: `2px solid transparent`,
};
const focusInput = {
  border: `1px solid ${Colors.primary}`,
};
// styling ends

const schema = yup
  .object({
    email_address: yup
      .string()
      .email("The e-mail address entered is incorrect")
      .required("E-mail address is required."),
    otp_in: yup
      .string()
      .required("Please enter the OTP.")
      .min(5, "Please fill the valid otp."),
  })
  .required();

export default function Reset() {
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email_address: "",
      otp_in: "",
    },
    resolver: yupResolver(schema),
    mode:'onBlur'
  });

  const { t } = useTranslation();
  const [formErrors, setFormErros] = useState("");
  const [loading, setLoader] = useState(false);
  const [enableEmail, setEnableEmail] = useState(false);

  const navigate = useNavigate();
  const onNavigate = (path) => {
    navigate(path);
  };
  const location = useLocation();
  const userDetail = watch();
  useEffect(() => {
    if (location.state.name) {
      setValue("email_address", location.state.name.email_address);
    }
    triggerOTP(location.state.name.email_address);
  }, []);

  const triggerOTP = async (email) => {
    const { data, status } = await onTriggerOtp({ email_address: email });
    if (status === 200) {
      toast.success(t("OTP has been sent successfully to your entered Email ID"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const fetchOTPVerify = async (email) => {
    const { data, status } = await onOtpVerify(email);
    if(data.status === 0){
      toast.error(t("Incorrect OTP"), {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
    else if(data.status === 1){
      onOtpVerification(data.otp_in);
    }
  };
  
  const onNewOtp = async () => {
    setEnableEmail(false)
    if(Object.keys(errors).length===0&&userDetail.email_address){
      let req = {
        email_address: userDetail.email_address.toLowerCase(),
        en_type: "dGFsZW50",
      };
      const { data, status } = await forgotPasswordEmail(req);
      if (data && data.status === 1) {
        setValue("otp_in", "");
        setFormErros("");
      } else {
        setFormErros(data && data.message);
      }
      triggerOTP(userDetail.email_address);
    }
  };

  const onOtpVerification = async (otp) => {
    setLoader(true);
    userDetail.email_address = userDetail.email_address.toLowerCase();
    const { data, status } = await forgotPasswordValidation(userDetail);
    if (data && data.status === 1) {
      navigate("/confirmpassword", { state: { name: data.code } });
      setFormErros("");
      setLoader(false);
    } else {
      setLoader(false);
      setFormErros(data && data.message);
    }
  };

  const handleChange = (val) => {
    setValue("otp_in", val);
  };

  const onChangeEmail=()=>{
    setEnableEmail(true)
    setValue("otp_in", '');
  }

  return (
    <UserCreationLayout>
      <HeaderWrapper onClick={() => onNavigate("/")}>
        <IoIosArrowBack color={Colors.primary} size={20} />
        <SignUpBtn>{t("Back")}</SignUpBtn>
      </HeaderWrapper>
      <IntroSection
        name={t("Reset Password")}
        description={t("Please provide the following details to reset your password.")}
      />
      <Divider />
      <FormWrapper>
        <GroupWrapper>
          <EmailHeader>
            <FormLabel>{t("Email address*")}</FormLabel>
            <UserHelpText onClick={() => onNavigate("/forget")}>
              {t("Change Email Address")}
            </UserHelpText>
          </EmailHeader>
          <Controller
            name="email_address"
            control={control}
            render={({ field }) => (
              <Input
                placeholder={t("Enter email address")}
                type="email"
                onBlur={onNewOtp}
                disabled
                {...field}
              />
            )}
          />
          {errors.email_address && (
            <ErrorField err={t(errors.email_address.message)} />
          )}
        </GroupWrapper>
        <GroupWrapper>
          <FormLabel>{t("Verification code*")} </FormLabel>
          <Controller
            name="otp_in"
            control={control}
            render={({ field }) => (
              <OtpInput
                value={userDetail.otp_in}
                onChange={handleChange}
                numInputs={5}
                focusStyle={focusInput}
                inputStyle={InputOtp}
                shouldAutoFocus
                isInputNum
                separator={<span></span>}
              />
            )}
          />
          <Fintext>
            <_text_>{t("Not received the code?")} </_text_>
            <LabelHighlightText onClick={onNewOtp}>
              {t("Send Again")}
            </LabelHighlightText>{" "}
          </Fintext>
          {errors.otp_in && <ErrorField err={t(errors.otp_in.message)} />}
        </GroupWrapper>
        {formErrors && <ErrorField err={t(formErrors)} />}
        {loading ? (
          <Loader />
        ) : (
          <Button onClick={handleSubmit(fetchOTPVerify)} name={t("Verify")} />
        )}
      </FormWrapper>
    </UserCreationLayout>
  );
}
